import * as Yup from "yup";

Yup.setLocale({
    mixed: {
        default: 'Campo inválido.',
        required: 'Campo obrigatório.'
    },
    string: {
        matches: 'Formato ou valor inválido.',
        email: 'Deve ser um email válido.'
    }
});
